import React from 'react';
import styles from "./styles.module.scss";
import { FaChevronRight } from "react-icons/fa";

const Card = ({ cardInfo }) => {
    const { heading, subHeading, Icon, onNextClick } = cardInfo
    return (
        <div className={`${styles['card']}`}>

            <div className='d-flex flex-column justify-content-between' style={{ flexGrow: 1.5 }}>

                <div className={`${styles['heading']}`}>{heading}</div>

                <div className={`${styles['sub-heading']}`}>{subHeading}</div>

                <span className={`${styles['click-cta']} m-0 mt-3`} onClick={onNextClick}>
                    Click here
                    <FaChevronRight className='ml-2' />
                </span>

            </div>

            <div className={`${styles['icon-wrapper']}`}><Icon /></div>

        </div>
    )
}

const ACardsGrid = ({ cardsInfo, className="" }) => {

    const updatedCardsInfo = cardsInfo?.filter(cardInfo => Boolean(cardInfo));

    return (
        <div className={`${styles['cards-grid']} ${className}`}>
            {updatedCardsInfo?.map(cardInfo => <Card cardInfo={cardInfo} key={cardInfo?.heading} />)}
        </div>
    );
}

export default ACardsGrid;